let date = new Date();

const APPCONFIG = {
    authUri: 'https://auth.slimopgewekt.nl/auth/login?returnUrl=',
    malfunctionapi: 'https://malfunctionapi.wijzijnopgewekt.nl/',
    //malfunctionapi: 'http://localhost:8080/',
    benchmarkApi: 'https://benchmarkapi.isopgewekt.app/',
    DateTimeFormat: 'DD-MM-YYYY HH:mm:ss',
    DateFormat: 'DD-MM-YYYY',
    DBDateFormat: 'YYYY-MM-DD',
    MySQLDateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
    DateDisplayFormat: 'DD MMM YYYY',
    DBDatePattern: /(\d{4})-(\d{2})-(\d{2})/,
    resetCache: false,
    jwtTokenName: 'wijzijnopgewekt_jwt',
    googleApiKey: 'AIzaSyANRoa_hgO7Y0dKmWObrplwFqqNpoQsrh0',
    defaults: {
        malfunction: {
            key: '0',
            id: 0,
            klantkey: '0',
            klant: '',
            locatie: '',
            locatie_id: 0,
            storingtype: 'Omvormer',
            aanmeldingsdatum: date,
            contactpersoon: "",
            contactgegevens: "",
            beschrijving: "",
            zichtbaar_voor_klant: true,
            actions: []
        },
        action: {
            id: 0,
            datum_gepland: '',
            datum_uitgevoerd: '',
            wat_te_doen: '',
            meenemen: '',
            opgelost: false,
            gecommuniceerd_klant: false,
            uren_besteed: 0,
            opmerkingen: 'STANDAARD OPMERKINGEN',
            fotos: []
        },
        storingtypen: [
            {
                type: "Omvormer",
                subtypes: ["Geen gegevens", "Lage opwek", "Vreemde waardes"],
                solutions: ["Omvormer gereset", "Kabels vervangen", "Logger gerepareert", "Omvormer Vervangen"]
            },
            {
                type: "Logger",
                subtypes: ["Geen gegevens", "Kiosk geen internet", "Kiosk scherm reageert niet"],
                solutions: ["Internetprobleem opgelost", "SD Kaart vervangen"]
            },
            {
                type: "PV",
                subtypes: ["Paneel kapot", "Paneel los", "Probleem AC Zijde", "Probleem DC Zijde"],
                solutions: ["Panelen vervangen", "Opgelost"]
            },
            {
                type: "LED",
                subtypes: ["Storing lampen", "Storing Educube", "Lamp kapot"],
                solutions: ["Lamp gerepareerd", "Lamp vervangen", "Educube gerepareert", "Educube vervangen"]
            },
            {
                type: "Beheer",
                subtypes: ["Overig"], // ?
                solutions: ["Overig"] // ?
            }
        ],
    }
}

module.exports = APPCONFIG;



// WEBPACK FOOTER //
// ./src/constants/config.js